import styled from 'styled-components'
import configs from '../../config'
import Cookies from 'js-cookie'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import { formatPrice } from '../../helpers/utils'
export default function OrderUserListItem({ order }) {
  const dispatch = useDispatch()
  const [slip, setSlip] = useState([])
  const [showSlip, setShowSlip] = useState(null)

  const fetchSlip = async (orderId) => {
    dispatch({ type: 'loading_show' })
    setShowSlip(true)
    try {
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')

      const order = await fetch(`${configs.apiAdminGateway}/api/v3/admin/orders/${orderId}`, {
        headers: myHeaders,
      }).then((response) => response.json())

      fetch(`${configs.apiAdminGateway}/api/v2/admin/payments/${order.data.paymentId}/pop`, {
        headers: myHeaders,
      })
        .then((response) => response.json())
        .then(async (result) => {
          if (result.data.length > 0) {
            setSlip(result.data)
            return
          }
          Swal.fire({
            title: 'ไม่พบข้อมูลสลิป',
            icon: 'error',
            confirmButtonColor: Colors.SOFT_BLUE,
            confirmButtonText: 'ยืนยัน',
            backdrop: false,
          })
        })
    } catch (error) {
      console.error(error)
    }
    dispatch({ type: 'loading_hide' })
  }

  return (
    <CardContainer>
      <RowData>
        <span>เลขที่ใบสั่งซื้อ</span>
        <span>{order.orderNo}</span>
      </RowData>
      <RowData>
        <span>ราคา</span>
        <span>{formatPrice(order.price)} บาท</span>
      </RowData>
      <RowData>
        <span>สถานะ</span>
        {order.status === 'SUCCESS' && <span style={{ color: '#06C755' }}>ซื้อสำเร็จ</span>}
        {order.status === 'CANCEL' && <span style={{ color: '#E32321' }}>ยกเลิก</span>}
        {order.status === 'CONFIRMED' && <span style={{ color: '#0071C2' }}>รอแจ้งโอน</span>}
      </RowData>
      {slip.length > 0 && showSlip && (
        <RowData
          style={{
            display: 'flex',
            flexDirection: 'flex-col',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              flexDirection: 'column',
            }}
          >
            {slip.map((item, i) => (
              <img key={i} src={item.imageURL} alt="slip" style={{ width: '50%' }} />
            ))}
          </div>
          <CloseSlip onClick={() => setShowSlip(false)}>x</CloseSlip>
        </RowData>
      )}
      <Button onClick={() => fetchSlip(order.id)}>Show Slip</Button>
    </CardContainer>
  )
}

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const RowData = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
`

const Button = styled.button`
  background-color: #0071c2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  width: 100%;
`

const Table = styled.table`
  border: solid;
  width: 100%;
`

const TD = styled.td`
  border: solid;
  padding: 8px;
`

const TR = styled.tr`
  border: solid;
`

const TH = styled.th`
  border: solid;
  padding: 8px;
  text-align: center;
`
const CloseSlip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  margin-left: 10px;
  cursor: pointer;
`

const NoteLog = styled.div`
  margin-bottom: 16px;
`
